<template>
    <div class="box bg-white curve-box text-center m20 shadow-box" :class="className">
        <slot></slot>
    </div>
</template>
<script>
export default {
    name: 'ShadowBox',
    props: ['className']
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/ShadowBox.vue